module.exports = __webpack_public_path__ + "img/is.542009f.svg";